import ConstructionStagePageContent from '../components/construction/ConstructionStage';

const ConstructionStagePage = () => {
  return <ConstructionStagePageContent />;
};

export default ConstructionStagePage;